import { useEffect, useState } from "react";
import { Box } from "@mui/system";
import chat_language_illustration from "../../assets/images/chats/chat_language_illustration.svg";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Modal,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getInviteUrl } from "../../appStore/actions/subscriber/action";
import { useNavigate } from "react-router-dom";
import { handleCopyClick } from "../../utils/copytoClipboard";
import { profileUpdate } from "../../appStore/actions/profile/action";
import { showToastMsg } from "../../appStore/actions/global/action";
import { CloseButton, CloseIcon } from "../../page/Profille/CustomDrawer";
import closeLogoBlack from "../../assets/images/chats/closeLogoBlack.svg";
import warningLogo from "../../assets/images/warning_icon.svg";
import { CustomButton } from "../../common/CustomButtons/CustomButtons";
import { colorSchemes, fontSizeSchemes } from "../../assets/commonFunction";

const classes = {
  inputField: {
    borderBottom: "1px solid grey",
    width: "100%",
    textAlign: "center",
    "& input": {
      textAlign: "center",
    },
  },
  image: {
    width: "100%",
  },
  headerBox: {
    display: "flex",
    width: "100%",
    padding: "0.2rem 0rem",
    justifyContent: "center",
    backgroundColor: "#F3F3F3 !important",
  },
};
const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p:2
};
const WarningPopup = ({
  open,
  closeModal,
  title,
  bodyContent,
  doneBtnText,
  continueAlone,
}) => {
  const handleClose = () => {
    closeModal();
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Box display={"flex"} alignItems={"center"} gap={"0.8rem"}>
          <Box>
            <CloseButton onClick={handleClose} size="small" variant="contained">
              <CloseIcon src={closeLogoBlack} alt="close" />
            </CloseButton>
          </Box>

          <Box display={"flex"} alignItems={"center"} gap={"0.4rem"}>
            <img src={warningLogo} alt="" />
            <Typography fontSize={"1rem"} variant="h6" fontWeight={700}>
              {title}
            </Typography>
          </Box>
        </Box>

        <Box p={"0.8rem 0rem"} mt={"1rem"} width={"90%"} margin={"auto"}>
          <Typography variant="h6" fontSize={"0.9rem"}>
            {bodyContent}
          </Typography>
        </Box>

        <Box
          mt={"1.4rem"}
          sx={{textAlign:"center"}}
        >
         
          <CustomButton
           variant="outlined"
            backgroundColor="#fff"
            color="#000000"
            borderRadius="2px"
            cursor="pointer"
            borderColor="#000000"
            padding="0.4rem 1rem"
            display="inline"
            handleClick={continueAlone}
          >
            {doneBtnText}
          </CustomButton>
        </Box>
      </Box>
    </Modal>
  );
};

const InviteComponent = () => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const [isChecked, setIsChecked] = useState(false);
  const [isWarningOpen, setWarningOpen] = useState(false);
  const inviteData = useSelector((state) => state?.subscriber);
  const firstGroupData = useSelector(
    (state) => state?.arkchatgroup?.firstGroup
  );
  const navigate = useNavigate();
  const handleChecked = () => {
    setIsChecked(!isChecked);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    async function apiCall() {
      dispatch(getInviteUrl(1, firstGroupData?.id));
    }
    apiCall();
  }, [dispatch]);
  //
  const handleToast = (type) => {
    if (type === "error") {
      dispatch(showToastMsg(appContent?.KEY52));
    } else {
      dispatch(showToastMsg(appContent?.KEY53));
    }
  };
  const handleCopyInviteClick = () => {
    handleCopyClick(
      inviteData?.inviteUrlData?.data?.inviteMessage,
      handleToast
    );
  };
  const handleBtnClick = () => {
    setWarningOpen(true);
  };
  const handleNavigate = () => {
    setWarningOpen(false);
    dispatch(profileUpdate({ is_first_invite_sent: true }, false));
    navigate("/chat");
  };
  return (
    <>
      <WarningPopup
        open={isWarningOpen}
        closeModal={() => setWarningOpen(false)}
        title={appContent?.KEY289}
        bodyContent={appContent?.KEY356}
        doneBtnText={appContent?.KEY357}
        continueAlone={handleNavigate}
      />
      <Box sx={{ height: "89vh" }} position={"relative"}>
        <Box mb={4} sx={classes?.headerBox}>
          <Typography fontSize={fontSizeSchemes.font18} fontWeight={700}>{appContent?.KEY285}</Typography>
        </Box>

        <Box width={"21%"} margin={"auto"}>
          <img
            style={{ width: "290px", height: "180px" }}
            src={chat_language_illustration}
            alt="createGroup"
          />
        </Box>
        <Box mt={2}>
          <Box margin="auto" width={"50%"}>
            <Typography align="center" variant="subtitle2" gutterBottom>
              {appContent?.KEY286}
            </Typography>
          </Box>

          <Box
            display={"flex"}
            width={"25%"}
            margin={"auto"}
            justifyContent={"center"}
            gap={"4%"}
            mt={"1rem"}
          >
            <CustomButton
              padding="0.4rem 1rem"
              color="#ffff"
              borderRadius="0.12rem"
              handleClick={() => handleCopyInviteClick()}
            >
              {appContent?.KEY13}
            </CustomButton>
          </Box>
          <Box mt={"0.8rem"} textAlign="center">
            <Typography fontSize={"0.75rem"} color={"#183242"} variant="body2">
              {appContent?.KEY288}
            </Typography>
          </Box>

          {/* <Box mt={"1.5rem"} textAlign="center">
            <Typography color={"#183242"} variant="body2">
              {appContent?.KEY118} {appContent?.KEY119}
            </Typography>
          </Box> */}
          <Box mt={"1.5rem"}>
            <Box textAlign={"center"} width={"90%"} margin={"auto"}>
              <FormControlLabel
                required
                sx={{
                  ".MuiFormControlLabel-label": {
                    fontSize: "1rem",
                  },
                }}
                control={
                  <Checkbox
                    style={{ color: "#183242" }}
                    checked={isChecked}
                    onChange={handleChecked}
                  />
                }
                label={appContent?.KEY287}
                labelPlacement="end"
              />
            </Box>
            <Box width={"100%"} position={"absolute"} bottom={"1rem"}>
              <CustomButton
                backgroundColor={isChecked ? "#fff" : "#fff"}
                borderColor={isChecked ? "#000000" : colorSchemes.lightGray}
                color={isChecked ? "#000000" : "#000000"}
                padding="0.5rem 2rem"
                borderRadius="0.12rem"
                variant="outlined"
                handleClick={isChecked ? handleBtnClick : null}
              >
                <Typography color={isChecked ? "#000000" : colorSchemes.lightGray}>
                  {" "}
                  {appContent?.KEY3}
                </Typography>
              </CustomButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default InviteComponent;
